<div class="decision-detail-host" (click)="onClose()" (keydown.escape)="onClose()" tabindex="-1">
  <aside class="decision-detail" (click)="$event.stopPropagation()" (keydown.escape)="onClose()" tabindex="-1">
    <header class="decision-detail__header">
      <div>
        <p class="decision-detail__eyebrow">{{ lang.translate('home.decisionDetail.eyebrow') }}</p>
        <h2 class="decision-detail__title">{{ lang.translate('home.decisionDetail.title') }}</h2>
      </div>
      <button
        type="button"
        class="decision-detail__close"
        (click)="onClose()"
        [attr.aria-label]="lang.translate('home.decisionDetail.close')"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </header>

    <ng-container *ngIf="!loading && !error && detail?.decision as decision; else detailState">
      <section class="decision-detail__section decision-detail__section--hero">
        <div class="decision-detail__hero-top">
          <div class="decision-detail__hero-copy">
            <p class="decision-detail__section-label">{{ lang.translate('home.decisionDetail.whyLabel') }}</p>
            <h3 class="decision-detail__decision-title">{{ formatDecisionTitle(decision.title) }}</h3>
            <p class="decision-detail__reason">{{ translatedDecisionReason }}</p>
          </div>

          <div class="decision-detail__hero-badges">
            <span class="decision-detail__hero-pill" [attr.data-state]="decision.state">
              {{ lang.translate('home.decisionStates.' + decision.state) }}
            </span>
            <span class="decision-detail__hero-pill" *ngIf="decision.dueAt">
              {{ lang.translate('home.decisionDetail.dueAt') }} · {{ decision.dueAt | date: 'mediumDate' }}
            </span>
          </div>
        </div>

        <dl class="decision-detail__meta-grid decision-detail__meta-grid--summary">
          <div class="decision-detail__meta-card">
            <dt>{{ lang.translate('home.decisionDetail.priority') }}</dt>
            <dd>
              <span class="decision-detail__meta-value">{{ priorityDisplay.label }} · {{ priorityDisplay.scoreLabel }}</span>
            </dd>
          </div>
          <div class="decision-detail__meta-card">
            <dt>{{ lang.translate('home.decisionDetail.risk') }}</dt>
            <dd>
              <span class="decision-detail__meta-value">{{ riskDisplay.label }}</span>
            </dd>
          </div>
          <div class="decision-detail__meta-card">
            <dt>{{ lang.translate('home.decisionDetail.confidence') }}</dt>
            <dd>
              <span class="decision-detail__meta-value">{{ confidenceDisplay.label }} · {{ confidenceDisplay.percentageLabel }}</span>
            </dd>
          </div>
          <div class="decision-detail__meta-card" *ngIf="decision.owner?.displayName">
            <dt>{{ lang.translate('home.decisionDetail.owner') }}</dt>
            <dd>
              <span class="decision-detail__meta-value">{{ decision.owner?.displayName }}</span>
            </dd>
          </div>
        </dl>
      </section>

      <section class="decision-detail__section decision-detail__section--action" #actionSection tabindex="-1">
        <p class="decision-detail__section-label">{{ lang.translate('home.decisionDetail.actionArea') }}</p>
        <p class="decision-detail__stack-copy">{{ lang.translate('home.decisionDetail.actionAreaCopy') }}</p>
        <div class="decision-detail__action-status" [attr.data-tone]="actionPresentation.statusTone">
          <p class="decision-detail__stack-title">{{ translatedActionSummaryLabel }}</p>
          <p class="decision-detail__stack-copy">{{ translatedActionSummaryCopy }}</p>
          <p class="decision-detail__feedback-note" *ngIf="actionDisabledReason">{{ actionDisabledReason }}</p>
        </div>

        <div class="decision-detail__action-groups" *ngIf="availableActions.length">
          <div class="decision-detail__action-group" *ngIf="selectedAction as currentAction">
            <p class="decision-detail__group-label">{{ lang.translate('home.decisionDetail.availableActions') }}</p>
            <p class="decision-detail__stack-copy">{{ lang.translate('home.decisionDetail.availableActionsCopy') }}</p>
            <div class="decision-detail__action-choices" role="list">
              <button
                type="button"
                class="decision-detail__action-choice"
                *ngFor="let action of availableActions; trackBy: trackByActionKey"
                [class.decision-detail__action-choice--active]="currentAction.actionKey === action.actionKey"
                [class.decision-detail__action-choice--disabled]="!action.enabled"
                [disabled]="actionLoading"
                [attr.aria-pressed]="currentAction.actionKey === action.actionKey"
                (click)="onSelectAction(action.actionKey)"
              >
                <span>{{ translateActionLabel(action) }}</span>
                <small *ngIf="!action.enabled && action.disabledReason">{{ translateActionDisabledCopy(action.disabledReason) }}</small>
              </button>
            </div>
            <div class="decision-detail__action-status" data-tone="neutral">
              <p class="decision-detail__stack-title">{{ translateActionLabel(currentAction) }}</p>
              <p class="decision-detail__stack-copy">{{ translatedSelectedActionDescription }}</p>
            </div>
          </div>

          <div class="decision-detail__action-group" *ngIf="showGroupedActionCatalog && secondaryActions.length">
            <p class="decision-detail__group-label">{{ lang.translate('home.decisionDetail.moreActions') }}</p>
            <div class="decision-detail__action-chip-row">
              <button
                type="button"
                class="btn btn-outline-secondary decision-detail__action-chip"
                *ngFor="let action of secondaryActions; trackBy: trackByActionKey"
                [disabled]="actionLoading"
                (click)="onSelectAction(action.actionKey)"
              >
                {{ translateActionLabel(action) }}
              </button>
            </div>
          </div>

          <div class="decision-detail__action-group" *ngIf="showGroupedActionCatalog && remediationActions.length">
            <p class="decision-detail__group-label">{{ lang.translate('home.decisionDetail.remediationActions') }}</p>
            <div class="decision-detail__action-chip-row">
              <button
                type="button"
                class="btn btn-outline-secondary decision-detail__action-chip"
                *ngFor="let action of remediationActions; trackBy: trackByActionKey"
                [disabled]="actionLoading"
                (click)="onSelectAction(action.actionKey)"
              >
                {{ translateActionLabel(action) }}
              </button>
            </div>
          </div>

          <div class="decision-detail__action-group" *ngIf="showGroupedActionCatalog && dangerActions.length">
            <p class="decision-detail__group-label">{{ lang.translate('home.decisionDetail.dangerActions') }}</p>
            <div class="decision-detail__action-chip-row">
              <button
                type="button"
                class="btn btn-outline-secondary decision-detail__action-chip decision-detail__action-chip--danger"
                *ngFor="let action of dangerActions; trackBy: trackByActionKey"
                [disabled]="actionLoading"
                (click)="onSelectAction(action.actionKey)"
              >
                {{ translateActionLabel(action) }}
              </button>
            </div>
          </div>

          <div class="decision-detail__action-group" *ngIf="showGroupedActionCatalog && disabledActions.length">
            <p class="decision-detail__group-label">{{ lang.translate('home.decisionDetail.unavailableActions') }}</p>
            <div class="decision-detail__action-chip-row">
              <button
                type="button"
                class="btn btn-outline-secondary decision-detail__action-chip"
                *ngFor="let action of disabledActions; trackBy: trackByActionKey"
                disabled
              >
                {{ translateActionLabel(action) }}
              </button>
            </div>
          </div>
        </div>

        <ul class="decision-detail__criteria" *ngIf="translatedCompletionCriteria.length">
          <li *ngFor="let criterion of translatedCompletionCriteria">{{ criterion }}</li>
        </ul>

        <div class="decision-detail__feedback" #feedbackRegion tabindex="-1" *ngIf="actionMessage || actionError">
          <p class="decision-detail__feedback-success" *ngIf="actionMessage">{{ actionMessage }}</p>
          <p class="decision-detail__feedback-error" *ngIf="actionError as currentActionError">{{ currentActionError.message }}</p>
        </div>

        <p class="decision-detail__inspect-hint" *ngIf="inspectActionHint as currentInspectHint">
          {{ currentInspectHint }}
        </p>

        <app-home-decision-action-form
          *ngIf="selectedActionNeedsForm && canRenderSelectedActionForm && selectedAction as currentFormAction"
          [action]="currentFormAction"
          [loading]="actionLoading"
          (submitRequest)="onActionFormSubmit($event)"
        ></app-home-decision-action-form>

        <p class="decision-detail__feedback-note" *ngIf="selectedActionUnavailableReason && selectedActionNeedsForm && !canRenderSelectedActionForm">
          {{ selectedActionUnavailableReason }}
        </p>

        <button
          *ngIf="showPrimaryAction"
          type="button"
          class="btn decision-detail__action"
          [class.btn-primary]="actionPresentation.primaryMode === 'execute'"
          [class.btn-outline-secondary]="actionPresentation.primaryMode === 'inspect' || actionPresentation.primaryMode === 'disabled'"
          [disabled]="isPrimaryActionDisabled"
          (click)="onPrimaryAction()"
        >
          {{ detailPrimaryActionLabel }}
        </button>
      </section>

      <app-home-decision-supporting-sections
        [view]="$any(this)"
        [decision]="decision"
      ></app-home-decision-supporting-sections>
    </ng-container>
    <ng-template #detailState>
      <div class="decision-detail__state" *ngIf="error as currentError; else detailLoading">
        <p class="decision-detail__stack-title">{{ currentError.title }}</p>
        <p class="decision-detail__stack-copy">{{ currentError.message }}</p>
        <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
          {{ lang.translate('home.general.retry') }}
        </button>
      </div>

      <ng-template #detailLoading>
        <output class="decision-detail__state" aria-live="polite">
          <p class="decision-detail__stack-copy">{{ lang.translate('home.general.loading') }}</p>
        </output>
      </ng-template>
    </ng-template>
  </aside>
</div>
